module.exports = __webpack_public_path__ + "img/pulse2.acc0ca77.jpg";